import { render, staticRenderFns } from "./InformationalCodeSnippet.vue?vue&type=template&id=2f10817b"
import script from "./InformationalCodeSnippet.vue?vue&type=script&lang=js"
export * from "./InformationalCodeSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports